/* eslint-disable max-lines */

import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import ProductReviews from "../product/reviews";
import ProductReviewsCards from "../product/reviews-cards";

const widgetSpecRoute = "/product-spec-images";

export const BadgeComponents = {
    lifetime: <StaticImage src="https://cdn.shopify.com/s/files/1/0168/9760/5686/files/lifetimewarranty.png" alt="Lifetime Warranty" placeholder="blurred" quality={100} />,
    tenYear: <StaticImage src="https://cdn.shopify.com/s/files/1/0168/9760/5686/files/10yearwarranty_51ab13f1-09b7-447d-b2b8-4280946cdd5b.png" alt="10 Year Warranty" placeholder="blurred" quality={100} />,
    fiveYear: <StaticImage src="https://cdn.shopify.com/s/files/1/0168/9760/5686/files/5yearwarranty_5b058e9c-26db-4605-9f34-422f366b1222.png" alt="5 Year Warranty" placeholder="blurred" quality={100} />,
    twoYear: <StaticImage src="https://cdn.shopify.com/s/files/1/0168/9760/5686/files/2yearwarranty.png" alt="2 Year Warranty" placeholder="blurred" quality={100} />,

    lifetimeNew: <StaticImage src="https://cdn.shopify.com/s/files/1/0168/9760/5686/files/lifetime-new.png" alt="Lifetime Warranty" placeholder="blurred" quality={100} />,
    tenYearNew: <StaticImage src="https://cdn.shopify.com/s/files/1/0168/9760/5686/files/10years-new.png" alt="10 Year Warranty" placeholder="blurred" quality={100} />,
    fiveYearNew: <StaticImage src="https://cdn.shopify.com/s/files/1/0168/9760/5686/files/5years-new.png" alt="5 Year Warranty" placeholder="blurred" quality={100} />,
    twoYearNew: <StaticImage src="https://cdn.shopify.com/s/files/1/0168/9760/5686/files/2_Year_Logo.png" alt="2 Year Warranty" placeholder="blurred" quality={100} />,
};

export const badgesByVehicles = [
    { type: "car", badges: [{ key: "west coast", Component: BadgeComponents.lifetimeNew }, { key: "supreme", Component: BadgeComponents.lifetimeNew }, { key: "elite", Component: BadgeComponents.tenYearNew }, { key: "5 layer", Component: BadgeComponents.fiveYearNew }, { key: "proguard", Component: BadgeComponents.twoYearNew }] },
    { type: "suv", badges: [{ key: "west coast", Component: BadgeComponents.lifetimeNew }, { key: "supreme", Component: BadgeComponents.lifetimeNew }, { key: "elite", Component: BadgeComponents.tenYearNew }, { key: "5 layer", Component: BadgeComponents.fiveYearNew }, { key: "proguard", Component: BadgeComponents.twoYearNew }] },
    { type: "truck", badges: [{ key: "west coast", Component: BadgeComponents.lifetimeNew }, { key: "supreme", Component: BadgeComponents.lifetimeNew }, { key: "elite", Component: BadgeComponents.tenYearNew }, { key: "5 layer", Component: BadgeComponents.fiveYearNew }, { key: "proguard", Component: BadgeComponents.twoYearNew }] },
    { type: "van", badges: [{ key: "west coast", Component: BadgeComponents.lifetimeNew }, { key: "supreme", Component: BadgeComponents.lifetimeNew }, { key: "elite", Component: BadgeComponents.tenYearNew }, { key: "proguard", Component: BadgeComponents.twoYearNew }] },
    { type: "seat", badges: [{ key: "leatherette", Component: BadgeComponents.tenYear }, { key: "camo", Component: BadgeComponents.tenYear }, { key: "neo", Component: BadgeComponents.tenYear }] },
    { type: "boat", badges: [{ key: "west coast", Component: BadgeComponents.lifetimeNew }, { key: "supreme", Component: BadgeComponents.lifetimeNew }, { key: "elite", Component: BadgeComponents.tenYearNew }, { key: "proguard", Component: BadgeComponents.fiveYearNew }] },
    { type: "jet ski", badges: [{ key: "west coast", Component: BadgeComponents.lifetimeNew }, { key: "supreme", Component: BadgeComponents.lifetimeNew }, { key: "elite", Component: BadgeComponents.tenYearNew }, { key: "proguard", Component: BadgeComponents.fiveYearNew }] },
    { type: "bimini", badges: [{ key: "west coast", Component: BadgeComponents.lifetimeNew }, { key: "supreme", Component: BadgeComponents.lifetimeNew }, { key: "elite", Component: BadgeComponents.tenYearNew }] },
    { type: "pontoon", badges: [{ key: "west coast", Component: BadgeComponents.lifetimeNew }, { key: "supreme", Component: BadgeComponents.lifetimeNew }, { key: "elite", Component: BadgeComponents.tenYearNew }] },
    { type: "motorcycle", badges: [{ key: "west coast", Component: BadgeComponents.lifetimeNew }, { key: "supreme", Component: BadgeComponents.lifetimeNew }, { key: "elite", Component: BadgeComponents.tenYearNew }, { key: "proguard", Component: BadgeComponents.twoYearNew }] },
    { type: "scooter", badges: [{ key: "west coast", Component: BadgeComponents.lifetimeNew }, { key: "supreme", Component: BadgeComponents.lifetimeNew }, { key: "elite", Component: BadgeComponents.tenYearNew }, { key: "proguard", Component: BadgeComponents.twoYearNew }] },
    { type: "atv", badges: [{ key: "west coast", Component: BadgeComponents.lifetimeNew }, { key: "supreme", Component: BadgeComponents.lifetimeNew }, { key: "elite", Component: BadgeComponents.tenYearNew }, { key: "proguard", Component: BadgeComponents.twoYearNew }] },
    { type: "utv", badges: [{ key: "west coast", Component: BadgeComponents.lifetimeNew }, { key: "supreme", Component: BadgeComponents.lifetimeNew }, { key: "elite", Component: BadgeComponents.tenYearNew }, { key: "proguard", Component: BadgeComponents.twoYearNew }] },
    { type: "snowmobile", badges: [{ key: "west coast", Component: BadgeComponents.lifetimeNew }, { key: "supreme", Component: BadgeComponents.lifetimeNew }, { key: "elite", Component: BadgeComponents.tenYearNew }, { key: "proguard", Component: BadgeComponents.fiveYearNew }] },
    { type: "rv", badges: [{ key: "supreme", Component: BadgeComponents.lifetimeNew }, { key: "elite", Component: BadgeComponents.tenYearNew }] }
];

export const widgets = [
    {
        keys: ["Supreme Car", "Supreme Truck", "Supreme Van", "Supreme Suv", "Supreme RV"], desktopImg: `${widgetSpecRoute}/car-supreme.png`, mobileImg: `${widgetSpecRoute}/car-supreme-mobile.png`,
    },
    {
        keys: ["Elite Car", "Elite Truck", "Elite Van", "Elite Suv", "Elite RV"], desktopImg: `${widgetSpecRoute}/car-elite.png`, mobileImg: `${widgetSpecRoute}/car-elite-mobile.png`,
    },
    {
        keys: ["5 Layer Car", "5 Layer Truck", "5 Layer Van", "5 Layer Suv"], desktopImg: `${widgetSpecRoute}/car-5l.png`, mobileImg: `${widgetSpecRoute}/car-5l-mobile.png`,
    },
    {
        keys: ["Proguard Car", "Proguard Truck", "Proguard Van", "Proguard Suv"], desktopImg: `${widgetSpecRoute}/car-proguard.png`, mobileImg: `${widgetSpecRoute}/car-proguard-mobile.png`,
    },
    {
        keys: ["Supreme ATV"], desktopImg: `${widgetSpecRoute}/atv-supreme.png`, mobileImg: `${widgetSpecRoute}/atv-supreme-mobile.png`,
    },
    {
        keys: ["Elite ATV"], desktopImg: `${widgetSpecRoute}/snowmobile-elite.png`, mobileImg: `${widgetSpecRoute}/snowmobile-elite-mobile.png`,
    },
    {
        keys: ["Proguard ATV"], desktopImg: `${widgetSpecRoute}/atv-proguard.png`, mobileImg: `${widgetSpecRoute}/atv-proguard-mobile.png`,
    },
    {
        keys: ["Supreme Bimini"], desktopImg: `${widgetSpecRoute}/bimini-bow-supreme.png`, mobileImg: `${widgetSpecRoute}/bimini-bow-supreme-mobile.png`,
    },
    {
        keys: ["Elite Bimini"], desktopImg: `${widgetSpecRoute}/bimini-bow-elite.png`, mobileImg: `${widgetSpecRoute}/bimini-bow-elite-mobile.png`,
    },
    {
        keys: ["Supreme Bimini"], tag: "Canvas", desktopImg: `${widgetSpecRoute}/bimini-canvas-boot-supreme.png`, mobileImg: `${widgetSpecRoute}/bimini-canvas-boot-supreme-mobile.png`,
    },
    {
        keys: ["Elite Bimini"], tag: "Canvas", desktopImg: `${widgetSpecRoute}/bimini-canvas-boot-elite.png`, mobileImg: `${widgetSpecRoute}/bimini-canvas-boot-elite-mobile.png`,
    },
    {
        keys: ["Supreme Bimini"], tag: "Boot", desktopImg: `${widgetSpecRoute}/bimini-canvas-boot-supreme.png`, mobileImg: `${widgetSpecRoute}/bimini-canvas-boot-supreme-mobile.png`,
    },
    {
        keys: ["Elite Bimini"], tag: "Boot", desktopImg: `${widgetSpecRoute}/bimini-canvas-boot-elite.png`, mobileImg: `${widgetSpecRoute}/bimini-canvas-boot-elite-mobile.png`,
    },
    {
        keys: ["Supreme Bimini"], tag: "Bow", desktopImg: `${widgetSpecRoute}/bimini-bow-supreme.png`, mobileImg: `${widgetSpecRoute}/bimini-bow-supreme-mobile.png`,
    },
    {
        keys: ["Elite Bimini"], tag: "Bow", desktopImg: `${widgetSpecRoute}/bimini-bow-elite.png`, mobileImg: `${widgetSpecRoute}/bimini-bow-elite-mobile.png`,
    },
    {
        keys: ["Supreme Jet Ski"], desktopImg: `${widgetSpecRoute}/jetski-supreme.png`, mobileImg: `${widgetSpecRoute}/jetski-supreme-mobile.png`,
    },
    {
        keys: ["Elite Jet Ski"], desktopImg: `${widgetSpecRoute}/jetski-elite.png`, mobileImg: `${widgetSpecRoute}/jetski-elite-mobile.png`,
    },
    {
        keys: ["Proguard Jet Ski"], desktopImg: `${widgetSpecRoute}/jetski-proguard.png`, mobileImg: `${widgetSpecRoute}/jetski-proguard-mobile.png`,
    },
    {
        keys: ["Supreme Motorcycle"], desktopImg: `${widgetSpecRoute}/motorsports-supreme.png`, mobileImg: `${widgetSpecRoute}/motorsports-supreme-mobile.png`,
    },
    {
        keys: ["Elite Motorcycle"], desktopImg: `${widgetSpecRoute}/snowmobile-elite.png`, mobileImg: `${widgetSpecRoute}/snowmobile-elite-mobile.png`,
    },
    {
        keys: ["Proguard Motorcycle"], desktopImg: `${widgetSpecRoute}/motorsports-proguard.png`, mobileImg: `${widgetSpecRoute}/motorsports-proguard-mobile.png`,
    },
    {
        keys: ["Supreme Scooter"], desktopImg: `${widgetSpecRoute}/scooter-supreme.png`, mobileImg: `${widgetSpecRoute}/scooter-supreme-mobile.png`,
    },
    {
        keys: ["Elite Scooter"], desktopImg: `${widgetSpecRoute}/snowmobile-elite.png`, mobileImg: `${widgetSpecRoute}/snowmobile-elite-mobile.png`,
    },
    {
        keys: ["Proguard Scooter"], desktopImg: `${widgetSpecRoute}/scooter-proguard.png`, mobileImg: `${widgetSpecRoute}/scooter-proguard-mobile.png`,
    },
    {
        keys: ["Supreme Pontoon"], desktopImg: `${widgetSpecRoute}/pontoon-supreme.png`, mobileImg: `${widgetSpecRoute}/pontoon-supreme-mobile.png`,
    },
    {
        keys: ["Elite Pontoon"], desktopImg: `${widgetSpecRoute}/pontoon-elite.png`, mobileImg: `${widgetSpecRoute}/pontoon-elite-mobile.png`,
    },
    {
        keys: ["Supreme Snowmobile"], desktopImg: `${widgetSpecRoute}/snowmobile-supreme.png`, mobileImg: `${widgetSpecRoute}/snowmobile-supreme-mobile.png`,
    },
    {
        keys: ["Elite Snowmobile"], desktopImg: `${widgetSpecRoute}/snowmobile-elite.png`, mobileImg: `${widgetSpecRoute}/snowmobile-elite-mobile.png`,
    },
    {
        keys: ["Proguard Snowmobile"], desktopImg: `${widgetSpecRoute}/snowmobile-proguard.png`, mobileImg: `${widgetSpecRoute}/snowmobile-proguard-mobile.png`,
    },
    {
        keys: ["Supreme UTV"], desktopImg: `${widgetSpecRoute}/utv-supreme.png`, mobileImg: `${widgetSpecRoute}/utv-supreme-mobile.png`,
    },
    {
        keys: ["Elite UTV"], desktopImg: `${widgetSpecRoute}/snowmobile-elite.png`, mobileImg: `${widgetSpecRoute}/snowmobile-elite-mobile.png`,
    },
    {
        keys: ["Proguard UTV"], desktopImg: `${widgetSpecRoute}/utv-proguard.png`, mobileImg: `${widgetSpecRoute}/utv-proguard-mobile.png`,
    },
    {
        keys: ["Supreme Boat"], desktopImg: `${widgetSpecRoute}/boat-supreme.png`, mobileImg: `${widgetSpecRoute}/boat-supreme-mobile.png`,
    },
    {
        keys: ["Elite Boat"], desktopImg: `${widgetSpecRoute}/boat-elite.png`, mobileImg: `${widgetSpecRoute}/boat-elite-mobile.png`,
    },
    {
        keys: ["Proguard Boat"], desktopImg: `${widgetSpecRoute}/boat-proguard.png`, mobileImg: `${widgetSpecRoute}/boat-proguard-mobile.png`,
    },
];


// Boat Supreme | Pontoon Supreme
const reviews1 = [
    {
        author_name: "Bruce E.",
        author_place: "Florida",
        content: "“Love the Warranty! Accidentally ripped my cover and they shipped me a brand new one”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/supreme-reviews-1.png?v=1719836823",
    },
    {
        author_name: "Shawn H.",
        author_place: null,
        content: "“It's been raining all week and my boat is still dry! That's what I call waterproof!”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/supreme-reviews-2.png?v=1719836823",
    },
    {
        author_name: "Joseph S.",
        author_place: "Chicago",
        content: "“Just trailed my boat from New York to Miami! Over a thousand miles! Love this cover.”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/supreme-reviews-3.png?v=1719836823",
    },

    {
        author_name: "Ernest R.",
        author_place: "San Diego",
        content: "“I like that I can use this boat cover on water as well, the ratchet system is a great feature.”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/supreme-reviews-4.png?v=1719836822",
    },
    {
        author_name: "Hugh M.",
        author_place: "Houston",
        content: "“We just had a hurricane and my boat is still dry! Definitely waterproof and impressed by the straps.”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/supreme-reviews-5.png?v=1719836823",
    },
    {
        author_name: "Brian H.",
        author_place: "Florida",
        content: "I’ve had my boat covers for 6 years now, tough covers. Just came back for a bimini top.”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/supreme-reviews-6.png?v=1719836822",
    },
];

// Boat Proguard | Pontoon Elite
const reviews2 = [
    {
        author_name: "Rick B.",
        author_place: "Boston",
        content: "“Their prices are unbeatable! Been shopping here for years.”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/proguard-review-1.png?v=1719836827",
    },
    {
        author_name: "Iris O.",
        author_place: "San Diego",
        content: "“My boat sits under a sap tree and this cover has saved my interior from thousands of dollars of damage!”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/proguard-review-2.png?v=1719836827",
    },
    {
        author_name: "George H.",
        author_place: "Chicago",
        content: "“Ordered two covers, great fitting. Got one for my boat as well, this is my third cover from these guys.”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/proguard-review-3.png?v=1719836828",
    },

    {
        author_name: "Thomas B.",
        author_place: "San Diego",
        content: "“Great protection for my boat under a shed with several families of pigeons. The cover keeps it looking like new!”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/proguard-review-4.png?v=1719836828",
    },
    {
        author_name: "Darren D.",
        author_place: "Florida",
        content: "“The cover fits perfectly and it's really to put on and off.”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/proguard-review-5.png?v=1719836828",
    },
    {
        author_name: "Neil",
        author_place: "Florida",
        content: "“Seen them on friends boats and they fit awesome. Just got mine and I love it. Highly recommend it!”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/proguard-review-6.png?v=1719836827",
    },
];

// Boat Elite
const reviews3 = [
    {
        author_name: "Alex J.",
        author_place: "Cincinnati, OH",
        content: "Fast Shipping and heavy duty for my boat. My cover prevents rain from pooling up. This cover will hold up great in northern winters.",
        image: "https://ssc-images-stg.s3.amazonaws.com/ej2nl3yc5tooeerbhjglegs7s5nz",
    },
    {
        author_name: "Steve C.",
        author_place: "Greenwich, CT",
        content: "My sealskin cover fit perfectly around my center console and outboard with the sewn in engine cover. Amazing value for the price.",
        image: "https://ssc-images-stg.s3.amazonaws.com/w6z2gdaibtmzpixp5dpgm50xdor7",
    },
    {
        author_name: "Jay S.",
        author_place: "San Francisco, CA",
        content: "I love how the covers are waterproof, the water just slides off! Amazing cover guys.",
        image: "https://ssc-images-stg.s3.amazonaws.com/pbcgmwcn74v05e2d4wgcifv0axx5",
    },
];

// Jet Ski Supreme
const reviews4 = [
    {
        author_name: "Bruce E.",
        author_place: "Boston",
        content: "“Love the Warranty! Accidentally ripped my cover and they shipped me a brand new one”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/bruce-e.png",
    },
    {
        author_name: "Shawn H.",
        author_place: "San Diego",
        content: "“It's been raining all week and my jet ski is still dry! That's what I call waterproof!”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/shawn-h.png",
    },
    {
        author_name: "Joseph S.",
        author_place: "Chicago",
        content: "“Just trailed my jet ski from New York to Miami! Over a thousand miles! Love this cover.”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/joseph-s.png",
    },

    {
        author_name: "Ernest R.",
        author_place: "San Diego",
        content: "“I like that I can use this jet ski cover on water as well, the built-in pull cord is a great feature.”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/ernest-r.png",
    },
    {
        author_name: "Hugh M.",
        author_place: "Florida",
        content: "“We just had a hurricane and my jet ski is still dry! Definitely waterproof and impressed by the straps.”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/hugh-m.png",
    },
    {
        author_name: "Brian H.",
        author_place: "Florida",
        content: "I’ve had my jet ski covers for 6 years now, tough covers.”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/brian-h.png",
    },
];

// Jet Ski Elite
const reviews5 = [
    {
        author_name: "Rick B.",
        author_place: "Boston",
        content: "“Their prices are unbeatable! Been shopping here for years.”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/rick-b.png",
    },
    {
        author_name: "Iris O.",
        author_place: "San Diego",
        content: "“My boat sits under a sap tree and this cover has saved my interior from thousands of dollars of damage!”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/iris-o.png",
    },
    {
        author_name: "George H.",
        author_place: "Chicago",
        content: "“Ordered two covers, great fitting. Got one for my sea doo and one for my kawasaki, love them!”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/george-h.png",
    },

    {
        author_name: "Thomas B.",
        author_place: "San Diego",
        content: "“Great protection for my jet ski sitting under a shed with several families of pigeons. The cover keeps it looking like new!”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/thomas-b.png",
    },
    {
        author_name: "Darren D.",
        author_place: "Florida",
        content: "“The cover fits perfectly and it's really easy to put on and off.”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/darren-d.png",
    },
    {
        author_name: "Neil",
        author_place: "Florida",
        content: "“Seen them on a friend's ski and they fit awesome. Just got mine and I love it. Highly recommend it!”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/neil.png",
    },
];

// Jet Ski ProGuard
const reviews6 = [
    {
        author_name: "Joann W.",
        author_place: "Boston",
        content: "“My son just ordered one of your jet ski covers and said it was the best cover he had ever seen”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/joann-w.png",
    },
    {
        author_name: "Daren L.",
        author_place: "San Diego",
        content: "“Great product and fast delivery!”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/daren-l.png",
    },
    {
        author_name: "Abel",
        author_place: "Chicago",
        content: "“Great customer service. I had questions about the cover and the chat on the website really helped.”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/abel.png",
    },

    {
        author_name: "Thomas B.",
        author_place: "San Diego",
        content: "“Great protection for my sea doo that sits outside all day. The cover keeps it looking like new!”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/thomas-b.png",
    },
    {
        author_name: "Ray Q.",
        author_place: "Florida",
        content: "“Quick and easy to purchase and the product lives up to the all the reviews.”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/ray-q.png",
    },
    {
        author_name: "Dorothy",
        author_place: "Florida",
        content: "“Easy to order. Great service and Superb quality product!”",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/dorothy.png",
    },
];

export const manualReviews = [
    {
        title: "elite",
        handles: ["center-console", "bass-boat", "t-top", "deck-boat", "ski-boat", "ski-tower"],
        data: { reviews: reviews2 },
        Component: ProductReviewsCards,
    },
    {
        type: "boat",
        reviews: [
            {
                key: "supreme",
                Component: ProductReviewsCards,
                data: { reviews: reviews1 },
            },
            {
                key: "elite",
                Component: ProductReviews,
                data: { reviews: reviews3 },
            },
            {
                key: "proguard",
                Component: ProductReviewsCards,
                data: { reviews: reviews2 },
            },
        ],
    },

    {
        type: "pontoon",
        reviews: [
            {
                key: "supreme",
                Component: ProductReviewsCards,
                data: { reviews: reviews1 },
            },

            {
                key: "elite",
                Component: ProductReviewsCards,
                data: { reviews: reviews2 },
            },
        ],
    },

    {
        type: "jet ski",
        reviews: [
            {
                key: "supreme",
                Component: ProductReviewsCards,
                data: { reviews: reviews4 },
            },

            {
                key: "elite",
                Component: ProductReviewsCards,
                data: { reviews: reviews5 },
            },

            {
                key: "proguard",
                Component: ProductReviewsCards,
                data: { reviews: reviews6 },
            },
        ],
    },
];



export const descriptions = {
    westCoast: "Engineered with our proven Supreme fabric and defined by West Coast Customs collaboration branding, performance meets design in a seamless package.",
    supreme: "Seal Skin Supreme is the most powerful cover available designed with SEAL-TEC technology and backed by a lifetime warranty.",
    elite: "Seal Skin Elite is a top-tier cover designed for ultimate Car protection at an exceptional value and backed by a 10-year warranty. Made from 100% polyester.",
    fiveLayer: "The Seal Skin 5-Layer cover provides unbeatable, all-season protection for your Car and is backed by a five-year warranty.",
    proguard: "Seal Skin ProGuard Car covers are crafted from cotton, offering a durable and affordable solution for Car protection and backed by a two years warranty."
}